<div class="mx-xl-0 p-5 px-xl-7 py-xl-8 evisa-bg-white rounded-5" [ngClass]="!showCloseBtn ? 'my-8 my-lg-13' : ''">
    @if (showCloseBtn) {
    <div class="d-flex justify-content-end">
        <img class="m-3 c-pointer" src="assets/icons/close-blue.svg" (click)="activeModal.dismiss('Cross click')">
    </div>
    }
    <div class="col-12 d-flex justify-content-center">
        <div class="">
            <p class="heading-2 ibm-semibold pb-2 linear-gradient-text ">{{ 'TERMS_CONDITIONS.TITLE' | translate }}
            </p>

            <div class="content-wrapper my-2">
                <p class="text-2 ibm-medium line-7 text-blue-2" [innerHTML]="'TERMS_CONDITIONS.INTRO' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_1.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_1.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_2.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_2.SUBSECTION_1.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_2.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_2.SUBSECTION_2.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_2.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_3.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_3.SUBSECTION_1.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_3.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_3.SUBSECTION_2.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_3.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_4.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_4.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_5.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_5.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_6.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_6.SUBSECTION_1.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_6.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 linear-gradient-text ibm-semibold">{{
                    'TERMS_CONDITIONS.SECTION_6.SUBSECTION_2.TITLE' |
                    translate }}</p>
                <div class="content-wrapper m-2">
                    <p class="text-2 ibm-medium line-7 text-blue-2"
                        [innerHTML]="'TERMS_CONDITIONS.SECTION_6.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_7.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_7.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_8.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_8.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_9.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_9.CONTENT' | translate"></p>
            </div>

            <p class="pb-2 linear-gradient-text heading-3 ibm-semibold">{{ 'TERMS_CONDITIONS.SECTION_10.TITLE' |
                translate }}
            </p>
            <div class="content-wrapper m-2">
                <p class="text-2 ibm-medium line-7 text-blue-2"
                    [innerHTML]="'TERMS_CONDITIONS.SECTION_10.CONTENT' | translate"></p>
            </div>

            <div class="content-wrapper m-2 pb-0">
                <p class="text-2 ibm-medium line-7 text-blue-2 " [innerHTML]="'TERMS_CONDITIONS.FOOTER' | translate">
                </p>
            </div>
        </div>
    </div>
</div>